/*global google*/
/*global MarkerClusterer*/

export default {
  init() {
    
    /*
    *  new_map
    *
    *  This function will render a Google Map onto the selected jQuery element
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since  4.3.0
    *
    *  @param  $el (jQuery element)
    *  @return  n/a
    */
    
    function new_map( $el ) {
      
      $el.addClass('loading');
      $('body').addClass('is-loading-map');
      
      // var
      var $markers = $el.find('.marker'), 
          imagePath = $el.data('cluster-marker-image-path');
      

      
      // vars
      var args = {
        zoom    : 16,
        center    : new google.maps.LatLng(0, 0),
        mapTypeId  : google.maps.MapTypeId.ROADMAP, 
        streetViewControl: false,
        rotateControl: false,
        mapTypeControl: false,
        zoomControl: true,
        styles: [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [ { "color": "#e7e5d8" } ] }, { "featureType": "landscape.natural", "elementType": "labels.text.stroke", "stylers": [ { "color": "#254c4c" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#46bcec" }, { "visibility": "on" } ] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [ { "color": "#557878" } ] }, { "featureType": "water", "elementType": "labels.text", "stylers": [ { "color": "#ffffff" } ] } ],
      };
      
      
      // create map
      var map = new google.maps.Map( $el[0], args);
      
      
      google.maps.event.addListenerOnce(map, 'idle', function(){
          // do something only the first time the map is loaded
          setTimeout(function() {
            $el.removeClass('loading');
            $('body').removeClass('is-loading-map');
          }, 500);
      });
      
      // add a markers reference
      map.markers = [];
      
      
      // add markers
      $markers.each(function(){
        
          add_marker( $(this), map );
        
      });

      //add_overlay( $el, map );      
      
      var clusterStyles = [
        {
          textColor: 'white',
          textSize: 14,
          url: imagePath+'icon-map-cluster1.png',
          height: 55,
          width: 55,
        },
       {
          textColor: 'white',
          textSize: 14,
          url: imagePath+'icon-map-cluster1.png',
          height: 55,
          width: 55,
        },
       {
          textColor: 'white',
          textSize: 14,
          url: imagePath+'icon-map-cluster1.png',
          height: 55,
          width: 55,
        },
      ];
      
      var options = {
          gridSize: 30,
          imagePath: imagePath+'icon-map-cluster',
          styles: clusterStyles,
      };
    
      new MarkerClusterer(map, map.markers, options);
      
      // center map
      setTimeout(function() {
        center_map( map );
      }, 1000);
      
      // return
      return map;
      
    }
    
    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since  4.3.0
    *
    *  @param  $marker (jQuery element)
    *  @param  map (Google Map object)
    *  @return  n/a
    */

    function add_overlay( $mapEl, map ) { // eslint-disable-line
      var overlayImage = $mapEl.attr('data-overlay-image'); // eslint-disable-line
      
      var bounds = new google.maps.LatLngBounds(),
          latlngFrom = new google.maps.LatLng( -28.259118185621773, 153.55834919362394 ), 
          latlngTo = new google.maps.LatLng( -28.261193620379146, 153.56130160820499 );
    
        bounds.extend( latlngFrom );
        bounds.extend( latlngTo );
          
          var imageMapType = new google.maps.ImageMapType({
              getTileUrl: function(coord, zoom) { // eslint-disable-line
                
                
                return null
                
/*
                if(zoom != 14) {
                  return null;
                }
                
                if (
                    bounds[0] > coord.x || coord.x > bounds[1] ||
                    bounds[0] > coord.y || coord.y > bounds[1]) {
                  return null;
                }
*/
                
/*
                if(coord.x == 32768 &&  coord.y == 32768) {
                  console.log('sup!');
                  return overlayImage;
                }
*/
                
                //return null;
                
/*
                if (zoom < 17 || zoom > 20 ||
                    bounds[zoom][0][0] > coord.x || coord.x > bounds[zoom][0][1] ||
                    bounds[zoom][1][0] > coord.y || coord.y > bounds[zoom][1][1]) {
                  return null;
                }
*/
          
              //return overlayImage; //['//www.gstatic.com/io2010maps/tiles/5/L2_', zoom, '_', coord.x, '_', coord.y, '.png'].join('');
            },
            tileSize: new google.maps.Size(256, 256),
          });
          
          map.overlayMapTypes.push(imageMapType);
          
          //KCOverlay.prototype
          //var overlayView = new google.maps.OverlayView(); // eslint-disable-line
                    
      //overlay = new KCOverlay(bounds, overlayImage, map);
      //console.log('+++++++ IMAGE: '+overlayImage);
      //console.log(overlay, map, overlayView);
    }
    
    function add_marker( $marker, map ) {
    
      // var
      var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    
      // create marker
      var marker = new google.maps.Marker({
        position            : latlng,
        map                 : map, 
        markerId            : $marker.attr('data-id'),
        shouldOpenInfoWindow: $marker.attr('data-open-info-window'),
        icon    : {
                      url: $marker.attr('data-icon'),
                      size: new google.maps.Size(120, 43),
                      scaledSize: new google.maps.Size(120, 43),
                  },
      });
      
      marker.iconNormal = {
                        url: $marker.attr('data-icon'),
                        size: new google.maps.Size(120, 43),
                        scaledSize: new google.maps.Size(120, 43),
                      };
                      
      marker.iconSelected = {
                        url: $marker.attr('data-icon-selected'),
                        size: new google.maps.Size(120, 43),
                        scaledSize: new google.maps.Size(120, 43),
                      };
    
      // add to array
      map.markers.push( marker );
      
      // if marker contains HTML, add it to an infoWindow
      if( $marker.html() )
      {
        // create info window
        var infowindow = new google.maps.InfoWindow({
            content    : $marker.html(),
        });
    
        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function() {
    
          marker.setIcon(marker.iconSelected);
    
          if (typeof marker.shouldOpenInfoWindow === 'undefined' || marker.shouldOpenInfoWindow === 'true') {
            infowindow.open( map, marker );
          }
          
          if((currentMarker == null) || (marker.markerId != currentMarker.markerId)) {
            
            if(currentMarker != null) {
              currentInfoWindow.close();
              currentMarker.setIcon(marker.iconNormal);
            }
            
            currentInfoWindow = infowindow;
            currentMarker = marker;
            
          } else if(marker.markerId == currentMarker.markerId) {
          
            if(currentMarker != null) {
              currentInfoWindow.close();
              currentMarker.setIcon(marker.iconNormal);
            }
            
            currentMarker = null;
            currentInfoWindow = null;
            
          }
          
        });
      }
    
    }
    
    /*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since  4.3.0
    *
    *  @param  map (Google Map object)
    *  @return  n/a
    */
    
    function center_map( map ) {
    
      // vars
      var bounds = new google.maps.LatLngBounds();
    
      // loop through all markers and create bounds
      $.each( map.markers, function( i, marker ){
    
        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
    
        bounds.extend( latlng );
    
      });
    
      // only 1 marker?
      if( map.markers.length === 1 )
      {
        // set center of map
          map.setCenter( bounds.getCenter() );
          map.setZoom( 14 );
      }
      else
      {
        // fit to bounds
        map.fitBounds( bounds );
      }
    
    }
    
    function initMaps() {
      $('.acf-map').each(function(){
        // create map
        new_map( $(this) );
      });
    }
    
    
    /*
    *  document ready
    *
    *  This function will render each map when the document is ready (page has loaded)
    *
    *  @type  function
    *  @date  8/11/2013
    *  @since  5.0.0
    *
    *  @param  n/a
    *  @return  n/a
    */
    // global var
    var currentInfoWindow = null, 
        currentMarker = null;
    
    initMaps();
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/map.js